import { API } from "@/lib/api";

export function containerProxyUrl(rawUrl) {
  if (!rawUrl) return null;
  return `${API}/fm/container?url=${encodeURIComponent(rawUrl)}`;
}

export function livePhotoUrl(layout, recordId, field, version) {
  const base = `${API}/fm/records/${recordId}/photo?layout=${encodeURIComponent(layout)}&field=${encodeURIComponent(field)}`;
  return version ? `${base}&v=${version}` : base;
}

export function isEditableField(fieldMeta) {
  if (!fieldMeta) return true;
  return fieldMeta.type === "normal" && fieldMeta.result !== "container";
}

export function isContainerField(fieldMeta, colKey) {
  if (fieldMeta?.result === "container") return true;
  // Fallback: when FileMaker layout-fields metadata is unavailable (e.g.
  // FM temporarily unreachable) we still want the Photo column to render as
  // an image. These are the well-known container column keys used in this app.
  if (!fieldMeta && colKey && ["photo", "pictures", "selling_history"].includes(colKey)) {
    return true;
  }
  return false;
}

export function formatCellValue(fieldMeta, value) {
  if (value === "" || value === null || value === undefined) return "-";
  if (fieldMeta?.result === "number") {
    const num = Number(value);
    if (!Number.isNaN(num)) {
      return num.toLocaleString(undefined, { maximumFractionDigits: 2 });
    }
  }
  return String(value).replace(/\r/g, " ").trim() || "-";
}

export function buildFieldTypeMap(fields) {
  const map = {};
  (fields || []).forEach((f) => {
    map[f.name] = f;
  });
  return map;
}

export const TABLE_COLUMNS_BY_LAYOUT = {
  "products general": [
    { key: "pictures", label: "Photo" },
    { key: "item no_main", label: "Item No" },
    { key: "GT_SKU", label: "SKU" },
    { key: "英文名称", label: "English Name" },
    { key: "category", label: "Category" },
    { key: "Price", label: "Price" },
    { key: "inventory qty", label: "Inventory Qty" },
    { key: "CBM", label: "CBM" },
    { key: "条码", label: "Barcode" },
  ],
  "main products": [
    { key: "photo", label: "Photo" },
    { key: "description", label: "Description" },
    { key: "item no", label: "Item No" },
    { key: "CBM", label: "CBM" },
    { key: "category", label: "Category" },
    { key: "date", label: "Date" },
  ],
};

export const SEARCH_PLACEHOLDER_BY_LAYOUT = {
  "products general": "Search by item no, SKU, name, or barcode...",
  "main products": "Search by item no or description...",
};

export const PORTAL_COLUMNS_MAIN_PRODUCTS = [
  { key: "customer_item_no", label: "Item No" },
  { key: "product::GT_SKU", label: "GT SKU" },
  { key: "product::Size", label: "Size" },
  { key: "product::Price", label: "Price" },
  { key: "product::装箱率", label: "Pcs/CTN" },
  { key: "product::inventory qty", label: "QTY" },
  { key: "product::长", label: "Length" },
  { key: "product::宽", label: "Width" },
  { key: "product::高", label: "Height" },
  { key: "product::毛重", label: "Gross Weight" },
];

export const PORTAL_COLUMNS_BEST_SELLING = [
  { key: "product::Size", label: "Size" },
  { key: "product::GT_SKU", label: "GT SKU" },
  { key: "product::装箱率", label: "Pcs/CTN" },
  { key: "product::GT_Price", label: "GT Price" },
  { key: "product::Price", label: "Price" },
];

export const GT_VISIBLE_ROLES = ["admin", "office", "gt_sales"];

export const canSeeGT = (user) => GT_VISIBLE_ROLES.includes(user?.role);

export const stripGtColumns = (columns) => columns.filter((c) => !String(c.key).includes("GT_SKU"));

export const PORTAL_COLUMNS_MOBILE = [
  { key: "product::Size", label: "Size" },
  { key: "product::Price", label: "Price" },
  { key: "product::装箱率", label: "Pcs/CTN" },
  { key: "product::inventory qty", label: "QTY" },
  { key: "barcode", label: "bar code" },
];
